import React, { useState, useEffect } from "react";
import { useImpactReadOnly, openImpactBoxIfReadOnly } from "app/routes/psp/management/useImpactReadOnly";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import InfoCard from "components/InfoCard/index";
import Dialog from "./Dialog"; // nuevo diálogo específico para Ledaga
import { callActionApi, getLedagaInfo } from "api/apiList";
import { callStartImpact, setReloadLedaga } from "actions/Impact";

const existItemsInImpact = (impactId, dataList) =>
  dataList.find((x) => x.impactId == impactId) !== undefined;

const Ledaga = () => {
  const dispatch = useDispatch();
  const readOnlyImpactView = useImpactReadOnly();
  const { selectedPrescription } = useSelector(({ management }) => management);
  const { impactStartDate, consentSigned, isCIRequired, reloadLedagaInfo } =
    useSelector(({ impact }) => impact);

  const msgConsentRequired = IntlGetText("impact.consentRequired");

  const [open, setOpen] = useState(false);
  const [ledagaInfo, setLedagaInfo] = useState(null);

  const handleClickOpen = () => {
    if (openImpactBoxIfReadOnly(readOnlyImpactView, () => setOpen(true))) return;
    if (!impactStartDate) {
      dispatch(callStartImpact(true));
      return;
    }
    if (isCIRequired && !consentSigned) {
      NotificationManager.warning(msgConsentRequired);
      return;
    }
    setOpen(true);
  };

  const callApi = (apiFunc, setData) => {
    callActionApi(
      apiFunc,
      setData,
      (error) => {
        if (typeof error === "string") NotificationManager.error(error);
      }
    );
  };

  const loadLedaga = () => {
    callApi(
      () => getLedagaInfo(selectedPrescription.patient.id),
      (data) => {
        setLedagaInfo(data);
      }
    );
  };

  const handleRequestClose = () => setOpen(false);

  return (
    <div>
      <InfoCard
        data={{
          icon: "hospital",
          title: IntlGetText("ledaga.cardTitle"),
          subTitle: IntlGetText("ledaga.cardSubTitle"),
          color: "#757575",
        }}
        onClickBox={handleClickOpen}
      />
      <Dialog
        open={open}
        handleRequestClose={handleRequestClose}
        loadLedaga={loadLedaga}
        disableBackdropClick={true}
        ledagaInfo={ledagaInfo}
      />
    </div>
  );
};

export default Ledaga;
